// apps/app/src/pages/admin/RoadmapPage.tsx
//
// /admin/roadmap (franklycatering #564) — the live roadmap. The Requests tab that sat
// beside it was removed in #1568: requests are filed straight to the board as GitHub
// issues, so there is no separate list to show.
//
// Route gate is <ProtectedRoute requiredRole="staff">, which admits staff, admin (via
// ProtectedRoute's adminCarveOut) and super_admin, and refuses viewer.

import { DashboardLayout } from "@/components/DashboardLayout";
import { RoadmapBoardContent } from "@/components/roadmap/RoadmapBoardContent";

export default function RoadmapPage() {
  return (
    <DashboardLayout title="Roadmap">
      <div className="space-y-4">
        <p className="text-muted-foreground text-sm">
          What's shipped, what's in flight, and what's next — read live from the
          issue tracker.
        </p>
        <RoadmapBoardContent />
      </div>
    </DashboardLayout>
  );
}
